import { useState, useEffect } from "react";

const NotificationToasts = ({ notifications, removeNotification }) => {
  // console.log(notifications)
  return (
    <div
      style={{
        position: "fixed",
        top: "1rem",
        right: "1rem",
        zIndex: 9999,
      }}
    >
      {notifications.map((notif, index) => (
        <div
          key={index}
          className="toast show"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{
            minWidth: "250px",
            marginBottom: "0.5rem",
            backgroundColor: "#fff", // solid background
            borderRadius: "8px", // rounded corners
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)", // subtle shadow
            border: "1px solid #ddd", // optional border
          }}
        >
          <div
            className="toast-header"
            style={{
              backgroundColor: "#f8f9fa",
              borderBottom: "1px solid #ddd",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0.5rem 0.75rem",
            }}
          >
            <strong>{notif.title || "New Notification"}</strong>
            <button
              type="button"
              className="btn-close"
              onClick={() => removeNotification(index)}
            ></button>
          </div>
          <div
            className="toast-body"
            style={{ padding: "0.5rem 0.75rem", fontSize: "0.9rem" }}
          >
            {notif.message}
            <hr style={{ margin: "0.5rem 0" }} />
            <small style={{ color: "#666" }}>{notif.timestamp}</small>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationToasts;